class CustomDropdown {
  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      placeholder: "Sélectionner une option",
      label: null,
      dropUp: false,
      onSelect: null,
      onOpen: null,
      onClose: null,
      ...options,
    };

    this.isOpen = false;
    this.selectedValue = null;
    this.selectedText = null;

    this.init();
  }

  init() {
    // Créer la structure HTML
    this.createHTML();

    // Ajouter les event listeners
    this.addEventListeners();

    // Initialiser l'état
    this.updateDisplay();

    // Add 'initialized' class to the custom-dropdown element
    this.element.classList.add('initialized');
  }

  createHTML() {
    const originalContent = this.element.innerHTML;
    const items = this.element.querySelectorAll("[data-value]");

    // Create label if provided
    if (this.options.label) {
      this.labelElement = document.createElement("label");
      this.labelElement.className = "custom-dropdown__label";
      this.labelElement.textContent = this.options.label;

      //  add a span label to keep the same width as the label
      this.labelSpan = document.createElement("span");
      this.labelSpan.className = "custom-dropdown__label-span";
      this.labelSpan.textContent = this.options.label;
      
    }

    // Créer le bouton toggle
    this.toggleButton = document.createElement("button");
    this.toggleButton.className = "custom-dropdown__toggle";
    this.toggleButton.type = "button";

    this.selectedSpan = document.createElement("span");
    this.selectedSpan.className = "custom-dropdown__selected";
    this.selectedSpan.textContent = this.options.placeholder;

    // Create SVG with proper namespace
    this.arrow = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    // this.arrow.className = "custom-dropdown__arrow";
    this.arrow.setAttribute("width", "16");
    this.arrow.setAttribute("height", "16");
    this.arrow.setAttribute("viewBox", "0 0 16 16");
    this.arrow.setAttribute("fill", "none");
    
    // Create path element with proper namespace
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M3 5.5L8 10.5L13 5.5");
    path.setAttribute("stroke", "currentColor");
    path.setAttribute("stroke-width", "1.5");
    // path.setAttribute("stroke-linecap", "round");
    // path.setAttribute("stroke-linejoin", "round");
    
    this.arrow.appendChild(path);

    this.toggleButton.appendChild(this.selectedSpan);
    this.toggleButton.appendChild(this.arrow);

    // Créer le menu dropdown
    this.dropdownMenu = document.createElement("div");
    this.dropdownMenu.className = "custom-dropdown__menu";
    
    // Add dropup class if option is enabled
    if (this.options.dropUp) {
      this.dropdownMenu.classList.add("custom-dropdown__menu--dropup");
    }

    // Créer les options
    items.forEach((item) => {
      const option = document.createElement("button");
      option.className = "custom-dropdown__option";
      option.type = "button";
      option.textContent = item.textContent.trim();
      option.dataset.value = item.dataset.value;

      this.dropdownMenu.appendChild(option);
    });

    // Vider l'élément original et ajouter la nouvelle structure
    this.element.innerHTML = "";
    
    // Add label first if it exists
    if (this.labelElement) {
      this.element.appendChild(this.labelElement);
      this.element.appendChild(this.labelSpan);
    }
    
    this.element.appendChild(this.toggleButton);
    this.element.appendChild(this.dropdownMenu);

    // Masquer les éléments originaux
    items.forEach((item) => {
      item.style.display = "none";
    });
  }

  addEventListeners() {
    // Toggle du dropdown
    this.toggleButton.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggle();
    });

    // Sélection d'une option
    this.dropdownMenu.addEventListener("click", (e) => {
      if (e.target.classList.contains("custom-dropdown__option")) {
        e.stopPropagation();
        this.select(e.target.dataset.value, e.target.textContent);
      }
    });

    // Fermer en cliquant à l'extérieur
    document.addEventListener("click", (e) => {
      if (!this.element.contains(e.target)) {
        this.close();
      }
    });

    // Fermer avec Escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
      }
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;
    this.dropdownMenu.classList.add("is-open");
    this.toggleButton.classList.add("is-open");
    
    // Add dropup class to toggle button if dropUp option is enabled
    if (this.options.dropUp) {
      this.toggleButton.classList.add("is-open--dropup");
    }

    if (this.options.onOpen) {
      this.options.onOpen(this.selectedValue, this.selectedText);
    }
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.dropdownMenu.classList.remove("is-open");
    this.toggleButton.classList.remove("is-open");
    this.toggleButton.classList.remove("is-open--dropup");

    if (this.options.onClose) {
      this.options.onClose(this.selectedValue, this.selectedText);
    }
  }

  select(value, text) {
    this.selectedValue = value;
    this.selectedText = text;

    this.updateDisplay();
    this.close();

    if (this.options.onSelect) {
      this.options.onSelect(value, text, this);
    }
  }

  updateDisplay() {
    if (this.selectedText) {
      this.selectedSpan.textContent = this.selectedText;
    } else {
      this.selectedSpan.textContent = this.options.placeholder;
    }
  }

  // Méthodes publiques
  getValue() {
    return this.selectedValue;
  }

  getText() {
    return this.selectedText;
  }

  setValue(value) {
    const option = this.dropdownMenu.querySelector(`[data-value="${value}"]`);
    if (option) {
      this.select(value, option.textContent);
    }
  }

  destroy() {
    // Nettoyer les event listeners si nécessaire
    this.close();
  }
}

// Fonction utilitaire pour initialiser facilement
function initCustomDropdown(selector, options = {}) {
  const elements = document.querySelectorAll(selector);
  const dropdowns = [];

  elements.forEach((element) => {
    dropdowns.push(new CustomDropdown(element, options));
  });

  return dropdowns;
}

// Exposer globalement
window.CustomDropdown = CustomDropdown;
window.initCustomDropdown = initCustomDropdown;
